export default {
  component: {
    Header: {
      title: 'Ostado, how it works',
      description: 'Flexible, expert-led lessons that fit your schedule, accessible from anywhere.'
    },
    HowItWorks: [
      {
        title: 'Select your ideal tutor',
        description: 'Discover your perfect tutor from 1500+ top-quality options',
        number: 1,
        bgColor: 'teal'
      },
      {
        title: 'Consultants will contact you',
        description: 'Our consultants will reach out to assist you in selecting a time and booking your classes.',
        number: 2,
        bgColor: 'pink'
      },
      {
        title: 'Now learn!',
        description: 'Learn easier with Ostado. Give us your feedback for better experience',
        number: 3,
        bgColor: 'green'
      }
    ],
    LearnPrivately: {
      title: 'Learn in private, shine in public',
      description: `<span class="text__body-2-md--semibold">Navigating the educational journey alone</span> can be a dark and long path in which students may lose sight of their goals and waste their energy and talent in the wrong place. The cost, of course, will be immense, not just in time and talent but in missed opportunities and unrealized potential.<br />
      Imagine a situation in which you can get academic help for all your questions from those who have already walked this path. Have a personal tutor who spends all his time knowing your strengths and weaknesses and getting the most benefit in the shortest time.<br />
        At Ostado, we believe that low grades or lack of interest in school is not a reflection of a student's true abilities. Every student deserves personalised education tailored to their unique needs by a tutor who truly understands them. That's why we're here—to help you find that perfect tutor who will unlock your full potential.<br />
        <span class="text__body-2-md--semibold">Our mission is simple: Your success.</span> Together, we'll make your educational journey brighter and more rewarding. With our private support, your job is to shine in public. Choose Ostado, and let's achieve greatness together.`
    },
    EveryStudent: {
      title: 'Every student, one supporter',
      description: `Success isn’t just a destination; it’s a journey, and at Ostado, we are your dedicated companions, not just facilitators. We firmly believe that no student should have to navigate this journey alone. That’s why Ostado assigns a personal supporter to each student—someone who’s always ready to listen, guide, and stand by you throughout your studies. <br /><br />
      After you begin your private lessons at Ostado, your supporter will be there every step of the way, ready to help with any questions or concerns you may have. Our supporters are more than just academic representatives; they are your advocates, ensuring that your path to success is clear of obstacles and full of confidence.<br /><br />
      With Ostado, you’re never alone on your educational journey. Let us help you achieve your full potential with the support you deserve.`
    },
    TutorSelection: {
      title: 'Help you to quickly choose the best tutors for you',
      description: `Choose Ostado and take the stress out of finding the right tutor. <br /><br />
      Your Concerns Are Our Priority<br />
      At Ostado, your needs come first. We’re committed to finding the perfect tutor for you swiftly so you don’t waste time on trial and error.<br />
      A Smart Choice for Saving Time and Energy <br /><br />
      But how do we make your choice more accessible and more effective?<br /><br />
      <ul>
        <li class="text-body-1 text__body-2-md--bold">Student Reviews: Trust the honest feedback from fellow students to guide your decision.</li><br />
        <li class="text-body-1 text__body-2-md--bold">Tutor Videos: Get a real sense of your tutor’s teaching style before committing.</li><br />
      </ul>
      Personalised Matching: Let Ostado do the hard work—tell us what you need, and we’ll find the tutor who’s the perfect fit for you.`
    },
    QualityPrice: {
      title: 'Quality sets the price',
      description: "At Ostado, we believe that quality should define the cost. Our team of experts carefully evaluates each tutor's credentials, skills, and experience to ensure that the price you pay reflects the value you receive. We’re committed to offering fair and transparent pricing that aligns with the tutor's proven expertise."
    },
    UnsureChoice: {
      title: 'Still unsure about your choice?',
      description: `<span class="text-body-1 text__body-2-md--bold">Try a Free Trial</span><br />
        We understand that finding the right tutor is a big decision. That’s why we offer free trial sessions to help you confidently choose the tutor who’s the best fit for you. If you’re pleased with your trial, you can start your lessons straight away, knowing you’ve made the right choice.<br />
        And remember, you’re never alone on this journey. We’re here to support you every step of the way.`
    }
  }
}
